export const formatCompactNumber = (number: number): string => {
  const units = [
    { threshold: 1_000_000_000_000, suffix: 'T' },
    { threshold: 1_000_000_000, suffix: 'B' },
    { threshold: 1_000_000, suffix: 'M' },
    { threshold: 1_000, suffix: 'K' },
  ];

  for (let i = 0; i < units.length; i++) {
    const { threshold, suffix } = units[i];

    if (number < threshold) continue;

    const rounded = Number((number / threshold).toFixed(1));

    if (rounded >= 1000 && i > 0) return `${rounded / 1000} ${units[i - 1].suffix}`;
    return `${rounded} ${suffix}`;
  }

  return `${number}`;
};
